package pl.finn.forms.utils

import io.kvision.core.StringPair
import pl.finn.forms.enums.BindedAs
import pl.finn.forms.enums.ViewType
import pl.finn.forms.model.DocumentTreeNode

object FormReadingUtils {

  fun isNextSiblingChoice(element: DocumentTreeNode): Boolean {
    if (element.metaModel?.choiceView != null && element.metaModel?.choiceView?.size!! > 1) return false
    for ((i, option) in element.children.withIndex()) {
      if (element.metaModel?.choiceView?.get(0)?.labels?.get(0)?.matches("${option?.name}|${getLabel(option!!)}")
        == true) {
        return false
      }
    }
    return true
  }

  fun isNextSiblingsELement(element: DocumentTreeNode) =
    element.metaModel?.particleView != null && element.metaModel?.particleView!![0]?.bindedAs == BindedAs.NEXT_SIBLING

  fun isSimpleChoiceElement(element: DocumentTreeNode) =
    element.metaModel?.viewType?.equals(ViewType.SIMPLE) == true && !element.metaModel?.choiceView.isNullOrEmpty()

  fun getLabel(element: DocumentTreeNode) =
    if (element.metaModel?.particleView != null && element.metaModel?.particleView?.get(0)?.isCheckbox == true) ""
    else if (!element.metaModel?.label.isNullOrEmpty()) element.metaModel?.label
    else if (!element.label.isNullOrEmpty()) element.label
    else element.metaModel?.labelArray?.get(0)

  fun addMetaValue(element: DocumentTreeNode) =
    if (!element.value.isNullOrEmpty()) element.value
    else if (!element.metaModel?.value.isNullOrEmpty() && !element.metaModel?.value.equals("null")) element.metaModel?.value
    else ""

  fun getRandomString(): String {
    val allowedChars = ('a'..'z') + ('A'..'Z')
    return (1..8)
      .map { allowedChars.random() }
      .joinToString("")
  }

  fun checkValidation(element: DocumentTreeNode): Array<String?> {
    with(element.typeName) {
      return when {
        this?.matches("decimal|KwotaPLN|TKwota2Nieujemna") == true -> arrayOf("\\d+(\\.\\d{1,2})?", "Wartość powinna mieć format liczbowy z 2 polami po kropce")
        this?.matches("gYear") == true -> arrayOf("[1-2][0-9][0-9]{2}", "Wartość powinna być liczbą całkowitą 4-cyfrową")
        this?.matches("nonNegativeInteger|int|positiveInteger") == true -> arrayOf("\\d+", "Wartość powinna być liczbą całkowitą")
        this?.matches("TData") == true -> arrayOf("((\\d{4})-(\\d{2})-(\\d{2}))", "Zły format daty, poprawny powinien mieć format 2020-10-30")
        this?.matches("TNrNIP") == true -> arrayOf("[1-9]((\\d[1-9])|([1-9]\\d))\\d{7}", "Wartość powinna zawierać 10 liczb")
        this?.matches("TNrPESEL") == true -> arrayOf("\\d{11}", "Wartość powinna zawierać 11 liczb")
        this?.matches("TNrREGON") == true -> arrayOf("^(\\d{7}|\\d{9}|\\d{14})$", "Wartość powinna zawierać 7, 9 lub 14 liczb")
        this?.matches("TAdresEmail") == true -> arrayOf("^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$", "Adres e-mail jest niepoprawny")
        this?.matches("TNrRachunkuPL") == true -> arrayOf("(PL)?\\d{26}", "Numer rachunku jest niewłaściwy")
        this?.matches("TSkrytkaEPuap") == true -> arrayOf("(/)[a-zA-Z0-9\\-_]{3,100}(/)[a-zA-Z0-9\\-_]{2,100}", "Błędny adres akrzynki ePUAP. przykładowy adres: \"/adres/skrzynki\"")
        else -> arrayOf(null, null)
      }
    }
  }

  fun checkMask(mask: String?): List<StringPair>? {
    with(mask) {
      return when {
        this?.matches("Zrachunku|Narachunek") == true -> listOf(
          StringPair("placeholder", "__ ____ ____ ____ ____ ____ ____"),
          StringPair("data-slots", "_"),
          StringPair("data-accept", "\\d"),
          StringPair("size", "32"),
          StringPair("onfocus", "FormUtils.applyDataMask(this);"),
        )
        this?.matches("KodPocztowy") == true -> listOf(
          StringPair("placeholder", "__-___"),
          StringPair("data-slots", "_"),
          StringPair("data-accept", "\\d"),
          StringPair("size", "5"),
          StringPair("onfocus", "FormUtils.applyDataMask(this);"),
          )
        else -> null
      }
    }
  }

  fun checkBankAccount(accountNo: String?): Boolean {
    if (accountNo == null) return false
    var filteredAccount = accountNo.replace("PL", "").replace(" ", "").replace("_", "")
    if (filteredAccount.length != 26 || filteredAccount.toRegex().matches("\\d{26}")) return false
    val controlNo = filteredAccount.substring(0, 2)
    filteredAccount = filteredAccount.substring(2, 26).concat("2521").concat(controlNo)
    val firstStep = filteredAccount.substring(0, 6).toInt() % 97
    val secondStep = (firstStep.toString().concat(filteredAccount.substring(6, 12))).toInt() % 97
    val thirdStep = (secondStep.toString().concat(filteredAccount.substring(12, 18))).toInt() % 97
    val fourthStep = (thirdStep.toString().concat(filteredAccount.substring(18, 24))).toInt() % 97
    val fifthStep = (fourthStep.toString().concat(filteredAccount.substring(24, 30))).toInt() % 97
    return fifthStep == 1
  }
}